import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import { useUpdateQuickPaymentMutation } from "Api/Mutations/User/useUpdateQuickPaymentMutation";
import { useBankingAccounts } from "Api/Queries/Accounts/useBankingAccounts";
import { useUserInfoQuery } from "Auth/Api/Queries/useUserInfoQuery";
import { Resources, useResource } from "Translations/Resources";

const SECTION_RESOURCES = Resources.UserSettings.QuickPayment;
const FIELD_RESOURCES = Resources.Pages.Content.BankAccounts.QuickPayment;

export const QuickPaymentToggle = () => {
  const { t } = useResource();
  const { data: userInfo, isLoading: isUserInfoLoading } = useUserInfoQuery();
  const { data: bankAccounts, isLoading: isAccountsLoading } =
    useBankingAccounts();
  const { mutate: updateQuickPayment } = useUpdateQuickPaymentMutation();

  const hasPrimaryAccount = (bankAccounts?.items ?? []).some(
    (account) => account.isPrimary,
  );
  const isLoading = isUserInfoLoading || isAccountsLoading;
  const isDisabled = isLoading || !hasPrimaryAccount;

  const checkbox = (
    <Checkbox
      checked={userInfo?.isQuickPaymentEnabled ?? false}
      disabled={isDisabled}
      onChange={(e) => updateQuickPayment({ isEnabled: e.target.checked })}
    />
  );

  return (
    <Stack gap={1}>
      <Typography variant="h6">{t(SECTION_RESOURCES.Title)}</Typography>
      <FormControl>
        <FormControlLabel
          control={
            !hasPrimaryAccount && !isLoading ? (
              <Tooltip title={t(FIELD_RESOURCES.Description)}>
                <span>{checkbox}</span>
              </Tooltip>
            ) : (
              checkbox
            )
          }
          label={t(FIELD_RESOURCES.Label)}
        />
      </FormControl>
      <Typography
        variant="body2"
        color="text.secondary"
        display="flex"
        alignItems="flex-start"
        gap={1}
      >
        <InfoOutlinedIcon sx={{ height: "1rem", width: "1rem", mt: 0.25 }} />
        {t(FIELD_RESOURCES.Description)}
      </Typography>
    </Stack>
  );
};
